import { AppRegistry } from 'react-native'
import App from './App'
import { LO_STO } from './lib'
import { Environment } from './config'
import { ENVIRONMENTS } from './lib/constants'
import uuid from 'uuid/v4'

AppRegistry.registerComponent('App', () => App)

if (Environment === ENVIRONMENTS.STAGE || Environment === ENVIRONMENTS.PROD) {
  console.debug = function () { }
}

// Logic to uniquely identify browser tab. Accounts for duplicated tabs.
// https://stackoverflow.com/questions/11896160/any-way-to-identify-browser-tab-in-javascript/36807854
const { sessionStorage } = window
if (!sessionStorage.TAB_ID || sessionStorage.closedLastTab === '2') {
  sessionStorage.TAB_ID = uuid()
}
sessionStorage.closedLastTab = '2'
window.addEventListener('beforeunload', () => { sessionStorage.closedLastTab = '1' })
window.addEventListener('unload', () => { sessionStorage.closedLastTab = '1' })
window.addEventListener('storage', (e) => {
  if (e.key === LO_STO.LOGOUT_EVENT) {
    window.location.href = '/'
  }
})

// Force deploy app #3
AppRegistry.runApplication('App', {
  rootTag: document.getElementById('root')
})
